import React from 'react'

/**
 * A screen's code (a lazy chunk) that could not be fetched: the request was
 * dropped (a background tab, a flaky connection) or the file is gone (a deploy
 * since the page loaded: hosting then answers the old file's URL with
 * index.html, which fails to run as a script).
 */
export const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' ||
  /Loading (CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
    error?.message || '',
  )

/**
 * Runs a dynamic import, retrying a chunk that failed to load (webpack fetches
 * it again on a new import). Any other error, and the last failure, is thrown.
 */
export const importWithRetry = (factory, retries = 2, delayMs = 1000) =>
  factory().catch((error) => {
    if (retries <= 0 || !isChunkLoadError(error)) throw error
    return new Promise((resolve) => setTimeout(resolve, delayMs)).then(() =>
      importWithRetry(factory, retries - 1, delayMs),
    )
  })

/** React.lazy whose chunk is retried before the screen fails. */
const lazyWithRetry = (factory) => React.lazy(() => importWithRetry(factory))

export default lazyWithRetry
